<div class="container">
  <ul class="fantasy-nav" #navContainer>
    <div class="line-indicator" #indicator></div>
    <a
      class="nav-item leaderboard-nav-item"
      [routerLink]="['/games/pickaplayer']"
      [routerLinkActive]="'active'"
      [routerLinkActiveOptions]="{ exact: true }"
      attr.aria-label="{{ 'game.nav. fantasy.screenreader' | translate }}"
    >
      <label>{{ 'fantasy.nav.featured' | translate: { fgbdefault: 'Play' } }}</label>
    </a>

    <a
      class="nav-item leaderboard-nav-item"
      [routerLink]="['/games/pickaplayer/up-next']"
      [routerLinkActive]="'active'"
      [routerLinkActiveOptions]="{ exact: true }"
      attr.aria-label="{{ 'game.nav.fantasy.up.next.screenreader' | translate }}"
    >
      <label>{{ 'fantasy.nav.up.next' | translate: { fgbdefault: 'Up Next' } }}</label>
    </a>

    <a
      class="nav-item leaderboard-nav-item"
      [routerLink]="['/games/pickaplayer/leaderboard']"
      [routerLinkActive]="'active'"
      [routerLinkActiveOptions]="{ exact: true }"
      attr.aria-label="{{ 'game.nav.fantasy.leaderboard.screenreader' | translate }}"
    >
      <label>{{ 'games.nav.fantasy.leaderboard' | translate: { fgbdefault: 'Leaderboard' } }}</label>
    </a>

    <a
      class="nav-item leaderboard-nav-item"
      [routerLink]="['/games/pickaplayer/results']"
      [routerLinkActive]="'active'"
      [routerLinkActiveOptions]="{ exact: true }"
      attr.aria-label="{{ 'game.nav.fantasy.results.screenreader' | translate }}"
    >
      <label>{{ 'fantasy.nav.results' | translate: { fgbdefault: 'Results' } }}</label>
    </a>

    <a
      class="nav-item leaderboard-nav-item"
      [routerLink]="['/games/pickaplayer/rules']"
      [routerLinkActive]="'active'"
      [routerLinkActiveOptions]="{ exact: true }"
      attr.aria-label="{{ 'game.nav.fantasy.rules.screenreader' | translate }}"
    >
      <label>{{ 'fantasy.nav.rules' | translate: { fgbdefault: 'Rules' } }}</label>
    </a>
  </ul>
</div>
